import { Modal, Button } from "flowbite-react";
type Props = {
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ModalOverwriteConfirmation({
  onConfirm,
  onCancel,
}: Props) {
  return (
    <Modal size={"md"} show={true} onClose={onCancel} dismissible>
      <Modal.Header>
        <h2 className="text-black">Confirmação de Substituição</h2>
      </Modal.Header>
      <Modal.Body className="text-black">
        <div className="text-center">
          <p className="text-lg font-semibold mb-4">
            Já existe um certificado salvo. <br />
          </p>
          <p className="text-gray-700">
            Deseja realmente substituir o certificado existente pelo novo
            arquivo?
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex justify-end space-x-4">
        <Button color="gray" onClick={onCancel}>
          Cancelar
        </Button>
        <Button
          className="bg-[#E44131] hover:bg-[#c4362a] text-white"
          onClick={onConfirm}
        >
          Sim, Substituir
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
